export const companiesData = [
  {
    name: "Rio Preto",
    price: 12,
    id: 1,
  },
  {
    name: "Araçatuba",
    price: 15,
    id: 2,
  },
  {
    name: "Prata",
    price: 13,
    id: 12,
  },
  {
    name: "Gasodiesel",
    price: 12,
    id: 16,
  },
  {
    name: "Uberlândia",
    price: 12,
    id: 15,
  },
  {
    name: "Uberaba",
    price: 12,
    id: 12,
  },
  {
    name: "Paulinia",
    price: 12,
    id: 12,
  },
];